import apiClient from './client';

/**
 * Is this visitor in Russia (by IP, resolved server-side)? Used to hide links
 * to services blocked or restricted there. The answer is cached in
 * localStorage so repeat visits render without a flash; null = not known yet.
 */
export const readCachedIsRu = (): boolean | null => {
  try {
    const v = localStorage.getItem('geo_ru');
    return v === '1' ? true : v === '0' ? false : null;
  } catch {
    return null;
  }
};

export const fetchIsRu = async (): Promise<boolean> => {
  const res = await apiClient.get<{ ru: boolean }>('/geo');
  try {
    localStorage.setItem('geo_ru', res.data.ru ? '1' : '0');
  } catch {
    /* private mode etc. — fine, just no cache */
  }
  return res.data.ru;
};
